module.exports = __webpack_public_path__ + "static/media/base_sorteo_pdf_octubre_2022.5df632e3.pdf";